<template>
  <div class="min-h-screen bg-gray-50" style="padding: 0px;margin: 0px;">
        <!-- 添加插件弹窗 -->
        <div v-if="showAddDialog" class="fixed  bg-black bg-opacity-50 z-50 flex">
            <!-- <div class="bg-white rounded-lg  shadow-xl">
                  <div class="px-6 py-4 border-b flex items-center justify-between">
                  <h3 class="text-lg font-medium">添加插件</h3>
                  <button @click="showAddDialog = false" class="text-gray-400 hover:text-gray-600">
                  <i class="fas fa-times"></i>
                  </button>
                  </div>
            <div class="p-6">
            <div class="space-y-4">
            <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">插件名称</label>
            <input
            v-model="newPlugin.name"
            type="text"
            class="w-full px-4 py-2 text-sm border border-gray-200 !rounded-button focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            placeholder="请输入插件名称"
            >
            </div>
            <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">插件分类</label>
            <button
            class="w-full px-4 py-2 text-sm border border-gray-200 !rounded-button flex items-center justify-between bg-white"
            @click="showCategoryDropdown = !showCategoryDropdown"
            >
            <span>{{ getSelectedCategoryName }}</span>
            <i class="fas fa-chevron-down"></i>
            </button>
            <div v-if="showCategoryDropdown" class="absolute mt-1 w-[452px] bg-white border border-gray-200 rounded-lg shadow-lg">
            <div class="p-0">
                  <button
                  v-for="category in categories"
                  :key="category.id"
                  @click="selectCategory(category.id)"
                  class="w-full px-4 py-2 text-sm text-left hover:bg-gray-50 !rounded-button flex items-center"
                  >
                  <i :class="category.icon" class="mr-3"></i>
                  {{ category.name }}
                  </button>
            </div>
            </div>
            </div>
            <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">插件描述</label>
            <textarea
            v-model="newPlugin.description"
            class="w-full px-4 py-2 text-sm border border-gray-200 !rounded-button focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            rows="3"
            placeholder="请输入插件描述"
            ></textarea>
            </div>
            <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">版本号</label>
            <input
            v-model="newPlugin.version"
            type="text"
            class="w-full px-4 py-2 text-sm border border-gray-200 !rounded-button focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            placeholder="请输入版本号，如：1.0.0"
            >
            </div>
            </div>
            </div>
            <div class="px-6 py-4 border-t flex justify-end space-x-4">
            <button
            @click="showAddDialog = false"
            class="px-4 py-2 text-sm text-gray-600 border border-gray-200 !rounded-button hover:bg-gray-50"
            >
            取消
            </button>
            <button
            @click="addPlugin"
            class="px-4 py-2 text-sm text-white bg-blue-600 !rounded-button hover:bg-blue-700"
            >
            确认添加
            </button>
            </div>
            </div> -->
        </div>
  <!-- 顶部搜索区域 -->
  <div class="z-50">
  <div class="mx-auto px-4 py-4">
  <div class="flex items-center justify-between">
  <div class="relative flex-1">
        <input
        type="text"
        class="w-full pl-10 pr-4 py-2 text-sm border-none bg-gray-100 !rounded-button"
        placeholder="搜索插件..."
        v-model="searchQuery"
        >
        <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
        </div>
  <!-- <button
  @click="showAddDialog = true"
  class="ml-4 px-6 py-2 bg-blue-600 text-white !rounded-button whitespace-nowrap hover:bg-blue-700"
  >
  <i class="fas fa-plus mr-2"></i>添加插件
  </button> -->
  </div>
  </div>
  </div>

    <!-- 主要内容区域 -->
    <div class="mx-auto px-4 pt-2">
      <div class="flex gap-6">
        <!-- 左侧分类导航 -->
        <div class="w-60 bg-white rounded-lg shadow-sm p-4 h-fit sticky top-24">
          <h3 class="text-lg font-medium mb-4">插件分类</h3>
          <div class="space-y-2">
            <button 
              v-for="category in filteredCategories"
              :key="category.plus_category_id"
              @click="selectC(category)"
              :class="{
                'bg-blue-50 text-blue-600': currentCategory === category.plus_category_id,
                'hover:bg-gray-50': currentCategory !== category.plus_category_id
              }"
              class="w-full px-4 py-2 text-left !rounded-button whitespace-nowrap flex items-center"
            >
              <i :class="category.icon" class="mr-3"></i>
              {{ category.name }}
              <span class="ml-auto text-sm text-gray-400">{{ category.count }}</span>
            </button>
          </div>
        </div>

        <!-- 右侧插件展示区域 -->
        <div class="flex-1">
          <div class="mb-6 flex items-center justify-between">
            <h2 class="text-xl font-medium">
              <!-- {{ getCurrentCategoryName }}  -->
              <span class="text-gray-400 text-sm ml-2">共 {{ filteredPlugins.length }} 个插件</span>
            </h2>
          </div>
          <div class="grid grid-cols-4 gap-6">
            <div
              v-for="plugin in filteredPlugins"
              :key="plugin.id"
              class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-3 flex flex-col"
            >
              <router-link :to="plugin.path" class="flex flex-col flex-1">
                <div class="w-16 h-16 rounded-lg overflow-hidden mb-4">
                  <img  v-if="plugin.logo" :src="plugin.logo" class="w-full h-full object-cover" style="border: none;">
                  <Icon 
                  v-else 
                    :iconname="hasIcon(plugin.ico)" 
                    class="w-full h-full object-cover text-blue-500"
                  />
                
                </div>    
                <h4 class="text-lg font-medium mb-2" style="font-size:15px;margin-top: 0px;">{{ plugin.name }}</h4>
                <p class="text-gray-600 text-sm mb-4 flex-1"  style="font-size:12px;line-height: 16px;">{{ plugin.remark || plugin.description }}</p>
                <div class="flex items-center justify-between mt-auto pt-4 border-t">
                  <!-- <span class="text-sm text-gray-500">v{{ plugin.version }}</span> -->
                 
                </div>
                <!-- <div>
                  <div style="float: right;">删除</div>
                  <div style="clear: both;"></div>

                </div> -->
              </router-link>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';
import { getSessionStorage } from '@/utils/base'

export default {
  data() {
    return {
      loading: true,
      searchQuery: '',
      showAddDialog: false,
      showCategoryDropdown: false,
      searchQuery: '',
      currentCategory: "",
      listData: [], // 从API获取的原始数据
      categories: [], // 处理后的分类数据
      plugins: [] ,// 处理后的插件数据

      newPlugin: {
        name: '',
        plus_category_id: null,
        description: '',
        version: '',
      },
    };
  },
  computed: {
    // 过滤后的分类（包含权限验证）
    filteredCategories() {
      return this.categories.filter(category => 
        this.plugins.some(plugin => 
          plugin.plus_category_id === category.plus_category_id && this.hasPermission(plugin)
        )
      );
    },
    filteredPlugins() {
      return this.plugins
        .filter(plugin => 
          plugin.plus_category_id === this.currentCategory &&
          this.hasPermission(plugin) &&
          (plugin.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          plugin.description.toLowerCase().includes(this.searchQuery.toLowerCase()))
        );
    }
  },
  methods: {
    selectCategory(plus_category_id) {
        this.showCategoryDropdown = false;
       // this.currentCategory = plus_category_id;
      },
      selectC(item){
        this.currentCategory = item.plus_category_id
      },
    // 获取数据
    async getData() {
      try {
        const res = await PlusApi.plusList({}, true);
        this.listData = res.data.list;
        this.processData();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    // 处理原始数据
    processData() {
      this.categories = [];
      this.plugins = [];

      this.listData.forEach(category => {
        if (this.hasCategoryPermission(category)) {
          // 创建分类
          const newCategory = {
            plus_category_id: category.plus_category_id,
            name: category.name,
            icon: category.icon || 'fas fa-cube',
            count: category.children.filter(child => this.hasPermission(child)).length
          };
          this.categories.push(newCategory);

          // 处理插件数据
          category.children.forEach(plugin => {
            if (this.hasPermission(plugin)) {
              this.plugins.push({
                access_id: plugin.access_id,
                plus_category_id: category.plus_category_id,
                name: plugin.name,
                description: plugin.remark,
                version: plugin.version,
                path: plugin.path,
                ico: plugin.ico,
                logo: plugin.logo || this.generateDefaultLogo(plugin.name)
              });
            }
          });
        }
      });

      // 设置默认选中第一个分类
      if (this.categories.length > 0) {
        this.currentCategory = this.categories[0].plus_category_id;
      }
    },

    // 生成默认logo
    generateDefaultLogo(name) {
      return `/static/imgs/plus.jpg`;
    },

    // 权限验证
    hasPermission(plugin) {
      const authList = getSessionStorage('authlist') || {};
      return authList[plugin.path.toLowerCase()] === true;
    },

    hasCategoryPermission(category) {
      return category.children.some(child => this.hasPermission(child));
    },

    // 图标处理
    hasIcon(ico) {
      return ico && ico.length > 0 ? ico : '#icon-shop-applications';
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped>
/* 保留原有TailwindCSS样式 */
.plugin-item {
  transition: all 0.2s ease;
}
.plugin-item:hover {
  transform: translateY(-2px);
}

.plus-container{ min-height: 400px;}
    .plus-container .common-form{ margin-bottom: 0;}
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  }
  textarea {
  resize: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/plus/plus/index.vue